import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    marginTop: 22,
  },
  scrollViewContainerStyle: withTray => ({
    paddingVertical: 11,
    paddingBottom: withTray ? 110 : 30,
  }),
  divider: theme => ({
    marginHorizontal: 16.6,
    borderBottomColor: theme.colors.VFDivider.primary,
    borderBottomWidth: 1,
    marginBottom: 6,
    paddingTop: 20,
  }),

  subHeaderTitle: theme => ({
    ...Fonts.type.bold,
    marginHorizontal: 16.6,
    fontSize: 16.6,
    color: theme.colors.subtitle,
    marginBottom: 4,
    marginTop: 24,
  }),

  headerTitle: theme => ({
    color: theme.colors.headerTitleColor,
  }),
  headerContainer: {
    marginHorizontal: 16.6,
    marginBottom: 24,
    marginTop: -4,
  },
  errorIconStyle: {
    marginTop: 56.6,
  },
  filterContainerStyle: {
    paddingLeft: 16.6,
  },
  // DEPRECATEME: since [Release 22]
  containerViewStyle: {
    marginTop: Platform.OS === 'ios' ? 8 : 4,
    marginBottom: 35,
  },
  // End Deprecation
  dateFilterInfoContainer: {
    paddingHorizontal: 16,
    marginBottom: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dateFilterRange: theme => ({
    fontSize: 16.6,
    lineHeight: 18,
    color: theme.colors.textColorEight,
  }),
  dateFilterClear: theme => ({
    fontSize: 16.6,
    lineHeight: 18,
    color: theme.colors.hyperlinkFive,
  }),
});
